// //import React from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import styles from "./BreadCrum.module.css";

// const BreadCrum = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const categorySlug = searchParams.get("category");
//   const sectionSlug = searchParams.get("section");

//   const formatSlug = (slug) => {
//     if (!slug) return "";
//     return slug
//       .split("-")
//       .map((word) => {
//         if (word === "fda") return "FDA";
//         if (word === "ifu") return "IFU";
//         if (word === "kols") return "KOLs";
//         if (word === "moas") return "MOAs";
//         return word.charAt(0).toUpperCase() + word.slice(1);
//       })
//       .join(" ");
//   };

//   const sectionTitle = formatSlug(sectionSlug);
//   const categoryTitle = formatSlug(categorySlug);

//   return (
//     <div className={styles.breadcrumb}>
//       <span style={{ cursor: "pointer" }}>Newsroom</span>

//       {sectionTitle && (
//         <>
//           <span className={styles.separator}>/</span>

//           <span
//             style={{ cursor: "pointer" }}
//             onClick={() => navigate(`/newsroom?section=${sectionSlug}`)}
//           >
//             {sectionTitle}
//           </span>
//         </>
//       )}

//       {categoryTitle && (
//         <>
//           <span className={styles.separator}>/</span>
//           <span className={styles.active}>{categoryTitle}</span>
//         </>
//       )}
//     </div>
//   );
// };

// export default BreadCrum;
import React from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import styles from "./BreadCrum.module.css";

const BreadCrum = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const categorySlug = searchParams.get("category");
  const sectionSlug = searchParams.get("section");

  const formatSlug = (slug) => {
    if (!slug) return "";
    return slug
      .split("-")
      .map((word) => {
        if (word === "fda") return "FDA";
        if (word === "ifu") return "IFU";
        if (word === "kols") return "KOLs";
        if (word === "moas") return "MOAs";
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const isCategories = location.pathname === "/categories";
  const isBlogDetail = location.pathname === "/blog-detail";

  const categoryTitle = formatSlug(categorySlug);
  const sectionTitle = formatSlug(sectionSlug);

  // /blog-detail page
  if (isBlogDetail) {
    return (
      <div className={styles.breadcrumb}>
        <span>Newsroom</span>
        {sectionTitle && (
          <>
            <span className={styles.separator}>/</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/newsroom?section=${sectionSlug}`)}
            >
              {sectionTitle}
            </span>
          </>
        )}
        {categoryTitle && (
          <>
            <span className={styles.separator}>/</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/categories?section=${sectionSlug}&category=${categorySlug}`,
                )
              }
            >
              {categoryTitle}
            </span>
          </>
        )}
        <span className={styles.separator}>/</span>
        <span className={styles.active}>Blog Detail</span>
      </div>
    );
  }

  // /categories page
  if (isCategories) {
    return (
      <div className={styles.breadcrumb}>
        <span>Newsroom</span>
        {sectionTitle && (
          <>
            <span className={styles.separator}>/</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/newsroom?section=${sectionSlug}`)}
            >
              {sectionTitle}
            </span>
          </>
        )}
        {categoryTitle && (
          <>
            <span className={styles.separator}>/</span>
            <span className={styles.active}>{categoryTitle}</span>
          </>
        )}
      </div>
    );
  }

  // Default fallback
  return (
    <div className={styles.breadcrumb}>
      <span>Newsroom</span>
      {sectionTitle && (
        <>
          <span className={styles.separator}>/</span>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/newsroom?section=${sectionSlug}`)}
          >
            {sectionTitle}
          </span>
        </>
      )}
      {categoryTitle && (
        <>
          <span className={styles.separator}>/</span>
          <span className={styles.active}>{categoryTitle}</span>
        </>
      )}
    </div>
  );
};

export default BreadCrum;
